import { SupabaseLoadPersonalNotificationPreferencesRepository } from '@/shared/infra/repositories'
import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'
import type { LoadPersonalNotificationPreferences } from '@/shared/domain'

export function makeLoadPersonalNotificationPreferences(): LoadPersonalNotificationPreferences {
  return new SupabaseLoadPersonalNotificationPreferencesRepository(makeSupabaseEdgeHttpClient())
    .execute
}
